"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var removeQueryParam = function removeQueryParam(key, url) {
  if (url === void 0) {
    url = window.location.href;
  }

  try {
    var u = new URL(url);

    if ('URLSearchParams' in window) {
      var searchParams = new URLSearchParams(u.search);
      searchParams.delete(key);
      u.search = searchParams.toString();
      return u.toString();
    }
  } catch (err) {// noop
  }

  return url;
};

exports.default = removeQueryParam;